import { Colors, Heading, Icon, Text, type IconName } from '@amelio/ui-library';

import { HandDrawnHighlight } from './HandDrawnHighlight';
import { parseHighlightText } from './utils';

export type TipItemProps = {
    icon: IconName;
    title: string;
    text: string;
    highlightWord?: string;
};

const TipItem = ({ icon, title, text, highlightWord }: TipItemProps) => {
    const renderTitle = () => {
        if (!highlightWord) {
            return title;
        }

        const parts = parseHighlightText(title, highlightWord);

        if (!parts) {
            return title;
        }

        return (
            <>
                {parts.beforeText}
                {parts.lastCharBefore}
                {parts.spaceBefore}
                <span className={'relative inline-block'}>
                    <span className={'relative z-10'}>{parts.highlightText}</span>
                    <HandDrawnHighlight width={parts.calculatedWidth} />
                </span>
                {parts.afterHighlight}
            </>
        );
    };

    return (
        <div className={'flex flex-col gap-3 sm:flex-row'}>
            <div className={'flex justify-center sm:justify-start'}>
                <Icon
                    aria-hidden
                    name={icon}
                    color={Colors.PRIMARY}
                    className={
                        'bg-base-100 !h-18 !w-18 shrink-0 rounded-full p-1 sm:!h-13 sm:!w-13'
                    }
                />
            </div>

            <div>
                <Heading
                    level={3}
                    weight={'semibold'}
                    color={Colors.BASE}
                    className={'mb-1 text-lg'}
                >
                    {renderTitle()}
                </Heading>

                <Text
                    size={'small'}
                    className={'text-[12px]'}
                >
                    {text}
                </Text>
            </div>
        </div>
    );
};

export default TipItem;
